<template>
  <div class="chartLine" v-loading="$store.state.user.loadingState">
    <template v-if="activeParamsOption.length">
      <div class="commonTitle">
        <div style="margin: 20px 0 0 25px">
          <el-radio-group v-model="cardActive">
            <el-radio-button
              v-for="(v, i) in activeParamsOption"
              :label="v.name"
              :key="i"
            ></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="commonContentBox chartComCont">
        <div class="timeSwitch">
          <DatePicker @dateChange="dateChange" :size="'mini'" />
          <div>
            <el-button type="primary" size="mini" @click="confirm">{{
              showType === "echarts" ? "查询" : "刷新"
            }}</el-button>
            <el-button type="primary" plain size="mini" @click="exportExcel"
              ><i class="el-icon-download el-icon--left"></i>EXCEL</el-button
            >
          </div>
        </div>
        <div class="rankChartsBox">
          <PublicEcharts
            :id="`myChartsDet`"
            :chartsData="chartsData"
            :options="dealLineData()"
            usePropsOptions
          />
        </div>
      </div>
    </template>
    <template v-else>
      <el-empty description="暂无遥测属性"></el-empty>
    </template>
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker/DatePicker";
import PublicEcharts from "@/components/PublicEcharts";
import api from "@/api";
import { exportExcelFun } from "@/assets/js/utils";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
const jsonList = require("@/assets/json/telemetry.json").data;
export default {
  name: "ChartLine",
  components: {
    DatePicker,
    PublicEcharts,
  },
  props: {
    activeItem: {
      type: Object,
      default: () => {},
    },
    activeParamsOption: {
      type: Array,
      default: () => [],
    },
    activeIdWithParams: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      chartsData: {
        xData: [],
        series: [],
        maxData: [],
        minData: [],
        avgData: [],
        tableDataList: [],
      },
      cardActive: "",
      cardActiveChild: "",
      cardActiveCHildData: [],
      startTime: this.$moment().startOf("day").format("x"),
      endTime: this.$moment().endOf("day").format("x"),
      showType: "echarts", //echarts or table
      tableData: [],
      tabHead: [
        { label: "参数名", prop: "nameFormat" },
        { label: "最新值", prop: "latest" },
        { label: "更新时间", prop: "latestTimeFormat" },
        { label: "最大值", prop: "max" },
        { label: "发生时间", prop: "maxTimeFormat" },
        { label: "最小值", prop: "min" },
        { label: "发生时间", prop: "minTimeFormat" },
        { label: "平均值", prop: "avg" },
      ],
      paramsKeys: "",
    };
  },
  // computed: {
  //   activeObj: function () {
  //     return `${this.activeItem?.id?.id || this.activeItem?.deviceId}-${this.activeParamsOption.map(item=>item.name).toString()}`
  //     // return {
  //     //   activeItem: this.activeItem,
  //     //   activeParamsOption: this.activeParamsOption,
  //     // };
  //   },
  // },
  watch: {
    activeIdWithParams: {
      handler(newvalue, oldvalue) {
        console.log("activeIdWithParams=====", newvalue, oldvalue);
        this.initActive();
      },
      deep: true,
    },
    // activeObj: {
    //   handler(newvalue, oldvalue) {
    //     console.log("activeObj=====", newvalue, oldvalue);
    //     this.initActive();
    //   },
    //   deep: true,
    // },
    cardActive: function (val) {
      const activeData =
        this.activeParamsOption.find((item) => item?.name == val) || {};
      const child = (activeData?.child || []).filter(
        (item) => item.name == "历史数据"
      );
      const newChildName = child?.[0]?.name || "";
      this.cardActiveCHildData = child;
      if (this.cardActiveChild === newChildName) {
        // console.log("---cardActive---confirm-")
        this.confirm();
      } else {
        this.cardActiveChild = newChildName;
      }
      // this.getChartsData();
    },
    cardActiveChild: function (val) {
      // console.log("--cardActiveChild---val---",val)
      this.getChartsData("cardActiveCHildData", val);
    },
  },
  methods: {
    initActive() {
      const newName = this.activeParamsOption?.[0]?.name || "";
      if (this.cardActive === newName) {
        const activeData =
          this.activeParamsOption.find((item) => item?.name == newName) || {};
        const child = (activeData?.child || []).filter(
          (item) => item.name == "历史数据"
        );
        this.cardActiveChild = child?.[0]?.name || "";
        this.cardActiveCHildData = child;
        // console.log("----initActive-if--confirm-")
        setTimeout(() => {
          this.confirm();
        }, 1000);
      } else {
        // console.log("----initActive---else-")
        this.cardActive = newName;
      }
    },
    dateChange(value) {
      this.startTime = this.$moment(value).startOf("day").format("x");
      this.endTime = this.$moment(value).endOf("day").format("x");
      // console.log(value, 'dateChange value');
    },
    confirm() {
      if (this.cardActiveCHildData.length) {
        this.getChartsData("cardActiveCHildData", this.cardActiveChild);
      } else {
        this.getChartsData("activeParamsOption", this.cardActive);
      }
    },
    getChartsData(dataName, val) {
      const activeData = this[dataName].find((item) => item?.name == val) || {};
      const { name = "", keys = "" } = activeData;
      // console.log('----getchartdata----',dataName, activeData)
      if (!keys) {
        this.$message.error("查询keys为空，请检查配置!");
        this.tableData = [];
        this.chartsData = {
          xData: [],
          series: [],
          maxData: max || [],
          minData: min || [],
          avgData: avg || [],
          tableDataList: tableDataList || [],
        };
        return;
      }
      // if (name == '实时数据') {
      //   this.showType = 'table'
      //   const params = {
      //     deviceId: this.activeItem?.id?.id || this.activeItem?.deviceId,
      //     keys,
      //   }
      //   this.getRealtimeTable(params)
      // } else {
      //   // if (name == '历史数据') {
      //   this.showType = 'echarts'
      //   const params = {
      //     deviceId: this.activeItem?.id?.id || this.activeItem?.deviceId,
      //     keys,
      //     pageSize: 1000000,
      //     page: 0,
      //     startTs: this.startTime,
      //     endTs: this.endTime,
      //   }
      //   this.getHistoryTable(params)
      // }
      if (name == "历史数据") {
        this.showType = "echarts";
        this.paramsKeys = keys;
        const params = {
          deviceId: this.activeItem?.id?.id || this.activeItem?.deviceId,
          keys,
          pageSize: 1000000,
          page: 0,
          startTs: this.startTime,
          endTs: this.endTime,
          keyNames: this.cardActive,
        };
        this.getHistoryTable(params);
      }
    },
    async getRealtimeTable(params) {
      // this.$store.commit("SET_LOADING", true);
      this.tableData = [];
      let res = await api.DMGetRealtimeTable(params);
      if (res?.data?.code == 200) {
        const data = (res?.data?.data || []).map((item) => {
          const { name, latestTime, maxTime, minTime } = item;
          const itemUnit =
            jsonList.find((v) => {
              return v.key == name;
            }) || {};
          const unit = !itemUnit?.unit ? "" : `(${itemUnit?.unit})`;
          return {
            ...item,
            nameFormat: `${name}${unit}`,
            latestTimeFormat: this.$moment(latestTime).format(
              "yyyy-MM-DD HH:mm:ss"
            ),
            maxTimeFormat: this.$moment(maxTime).format("yyyy-MM-DD HH:mm:ss"),
            minTimeFormat: this.$moment(minTime).format("yyyy-MM-DD HH:mm:ss"),
          };
        });
        this.tableData = data;
      } else {
        console.log("获取实时数据失败");
      }
    },
    async getHistoryTable(params) {
      // console.log("--getHistoryTable----params--",params)
      // this.$store.commit("SET_LOADING", true);
      let res = await api.DMGetHistoryTable(params);
      if (res?.data?.code == 200) {
        const { max, min, avg, tableDataList = [] } = res?.data?.data || {};
        const newData = {
          xData: [],
          series: [],
          maxData: max || [],
          minData: min || [],
          avgData: avg || [],
          tableDataList: tableDataList || [],
        };
        Array.isArray(tableDataList) &&
          tableDataList.forEach((item, index) => {
            const { time, tskvList = [], unit } = item;
            if (index === 0) {
              const itemUnit =
                jsonList.find((v) => {
                  return v.key == tskvList?.[0]?.name;
                }) || {};
              newData.unit = unit ? unit : itemUnit?.unit;
            }
            newData.xData.push(this.$moment(time).format("HH:mm:ss"));
            Array.isArray(tskvList) &&
              tskvList.map((v, i) => {
                const { name, value } = v;
                const newName = params.keys.includes(",")
                  ? name
                  : this.cardActive;
                const seriesIndex = this._.findIndex(
                  newData.series,
                  function (o) {
                    return o.name === newName;
                  }
                );
                if (seriesIndex == -1) {
                  const obj = {
                    name: newName,
                    data: [value],
                    type: "line",
                    symbolSize: 8,
                    itemStyle: {
                      color: EchartsLightColor[i],
                    },
                    animation: true,
                    markPoint:
                      this.paramsKeys === "RunSign"
                        ? null
                        : {
                            data: [
                              { type: "max", name: "Max" },
                              { type: "min", name: "Min" },
                            ],
                          },
                    // markLine:
                    //   this.paramsKeys === "RunSign"
                    //     ? null
                    //     : {
                    //         data: [{ type: "average", name: "Avg" }],
                    //       },
                  };
                  newData.series.push(obj);
                } else {
                  newData.series[seriesIndex].data.push(value);
                }
              });
          });
        this.chartsData = newData;
      } else {
        console.log("获取图表失败");
      }
    },
    dealLineData() {
      let _this = this;
      let option = {
        grid: {
          top: "60px",
          left: "40px",
          right: "60px",
          bottom: "30px",
        },
        xAxis: {
          type: "category",
          axisLabel: {
            color: "#CBCBCB",
            fontSize: 12,
            margin: 15,
          },
          data: [],
        },
        yAxis: {
          type: "category",
          axisLabel: {
            color: "#CBCBCB",
            fontSize: 12,
            margin: 15,
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [
          {
            data: [],
            type: "line",
          },
        ],
      };
      if (this.chartsData?.xData?.length && this.chartsData?.series?.length) {
        //开关状态
        if (_this.paramsKeys === "RunSign") {
          option = {
            grid: {
              top: "60px",
              left: "40px",
              right: "60px",
              bottom: "30px",
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
              formatter: function (params) {
                let result = params[0].name + "<br>";
                params.forEach(function (item) {
                  result +=
                    item.marker +
                    " " +
                    item.seriesName +
                    " : " +
                    `${item.value == 0 ? "关" : "开"}` +
                    "</br>";
                });
                return result;
              },
            },
            legend: {
              top: "top",
              right: "10",
              textStyle: {
                color: "#333",
                fontSize: 12,
              },
            },
            xAxis: {
              type: "category",
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                color: "#CBCBCB",
                fontSize: 12,
                margin: 15,
              },
              data: this.chartsData?.xData || [],
            },
            yAxis: {
              type: "value",
              nameTextStyle: {
                color: "#666",
                fontSize: 12,
              },
              axisTick: {
                show: false,
              },
              axisLine: {
                show: false,
              },
              splitLine: {
                lineStyle: {
                  type: "solid",
                  color: "#EBEBEB",
                },
              },
              axisLabel: {
                color: "#999",
                fontSize: 12,
                formatter: (value, index) => {
                  if (_this.paramsKeys === "RunSign") {
                    if (value == 1) {
                      return "开启";
                    } else if (value == 0) {
                      return "关闭";
                    }
                    return "";
                  }

                  return value;
                },
              },
            },
            dataZoom: [
              {
                type: "inside",
              },
            ],
            series: this.chartsData?.series,
          };
        } else {
          option = {
            grid: {
              top: "60px",
              left: "40px",
              right: "60px",
              bottom: "30px",
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
              formatter: function (params) {
                let result = params[0].name + "<br>";
                params.forEach(function (item) {
                  result +=
                    item.marker +
                    " " +
                    item.seriesName +
                    " : " +
                    item.value +
                    `${_this.chartsData?.unit || ""}` +
                    "</br>";
                });
                return result;
              },
            },
            legend: {
              top: "top",
              right: "10",
              textStyle: {
                color: "#333",
                fontSize: 12,
              },
            },
            xAxis: {
              type: "category",
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                color: "#CBCBCB",
                fontSize: 12,
                margin: 15,
              },
              data: this.chartsData?.xData || [],
            },
            yAxis: {
              type: "value",
              name: `单位(${this.chartsData.unit})`,
              nameTextStyle: {
                color: "#666",
                fontSize: 12,
              },
              axisTick: {
                show: false,
              },
              axisLine: {
                show: false,
              },

              axisLabel: {
                color: "#999",
                fontSize: 12,
              },
              splitLine: {
                lineStyle: {
                  type: "solid",
                  color: "#EBEBEB",
                },
              },
              max: function (value) {
                if (value.max < 0) {
                  return Math.ceil(value.max * 0.9);
                }
              },
              min: function (value) {
                if (value.min > 0) {
                  return Math.floor(value.min * 0.9);
                }
              },
            },
            dataZoom: [
              {
                type: "inside",
              },
            ],
            series: this.chartsData?.series,
          };
        }
      }

      return option;
    },
    formatDataForExport({
      obj,
      data,
      formatTime = false,
      addTabHeader = false,
      tabHeader = [],
      translateName = false,
      addUnit = "",
    }) {
      const newObj = this._.cloneDeep(obj);
      Array.isArray(data) &&
        data.forEach((element, index) => {
          const { name, value, time } = element;
          const newName = this.paramsKeys.includes(",")
            ? name
            : this.paramsKeys;
          newObj[translateName ? newName : name] = value;
          const unit = !!addUnit ? `(${addUnit})` : "";
          addTabHeader &&
            tabHeader.push({
              label: this.cardActiveCHildData[0].keys.includes(",")
                ? `${name}${unit}`
                : `${this.cardActive}${unit}`,
              prop: name,
            });
          if (formatTime && index === 0) {
            newObj["timeFormat"] = this.$moment(time).format(
              "yyyy-MM-DD HH:mm:ss"
            );
          }
        });
      return { newObj, tabHeader };
    },
    dealChartsDataForExport() {
      const data = [];
      let tabHeader = [{ label: "时间", prop: "timeFormat" }];
      const { maxData, minData, avgData, tableDataList } = this.chartsData;
      const {
        tskvList: maxList,
        note: maxName = "范围最大值",
        unit = "",
      } = maxData || {};
      const { tskvList: minList, note: minName = "范围最小值" } = minData || {};
      const { tskvList: avgList, note: avgName = "范围平均值" } = avgData || {};
      const objMax = this.formatDataForExport({
        obj: { remark: maxName },
        data: maxList,
        formatTime: true,
        addTabHeader: true,
        addUnit: unit,
      });
      const { newObj, tabHeader: addHeader } = objMax;
      tabHeader = [...tabHeader, ...addHeader];
      data.push(newObj);
      const objMin = this.formatDataForExport({
        obj: { remark: minName },
        data: minList,
        formatTime: true,
      }).newObj;
      data.push(objMin);
      const objAvg = this.formatDataForExport({
        obj: { remark: avgName },
        data: avgList,
        formatTime: true,
      }).newObj;
      objAvg["timeFormat"] = "";
      data.push(objAvg);
      tabHeader.push({ label: "备注", prop: "remark" });

      Array.isArray(tableDataList) &&
        tableDataList.forEach((element) => {
          const { tskvList, time } = element;
          const obj = this.formatDataForExport({
            obj: {
              timeFormat: this.$moment(time).format("yyyy-MM-DD HH:mm:ss"),
            },
            data: tskvList,
            translateName: true,
          }).newObj;
          data.push(obj);
        });
      return { data, tabHeader };
    },
    exportExcel() {
      if (this.showType === "echarts") {
        const chartsData = this.dealChartsDataForExport();
        // console.log('--exportExcel---chartsData---', chartsData)
        const { data, tabHeader } = chartsData;
        if (data.length == 0) {
          this.$message.error("没有可导出的数据!");
          return false;
        }
        const excelTitle = `${this.activeItem?.name || ""}_${
          this.cardActive || ""
        }历史数据_${this.$moment(Number(this.endTime)).format("yyyy-MM-DD")}`;

        exportFile.xlsxFile(XLSX, excelTitle, {
          excel: exportExcelFun(tabHeader, data),
        });
      } else {
        const data = this.tableData;
        if (data.length == 0) {
          this.$message.error("没有可导出的数据!");
          return false;
        }
        const excelTitle = `${this.activeItem?.name || ""}_${
          this.cardActive || ""
        }实时数据_${this.$moment(Date.now()).format("yyyy-MM-DD HH:mm:ss")}`;
        const tabHeader = this.tabHead;
        // const tabHeader = [{ label: this.cardActive, prop: "nameFormat" }].concat(this.tabHead);

        exportFile.xlsxFile(XLSX, excelTitle, {
          excel: exportExcelFun(tabHeader, data),
        });
      }
    },
  },
  created() {
    this.initActive();
  },
};
</script>

<style lang="scss" scoped>
.chartLine {
  width: 100%;
  height: 100%;

  .chartComCont {
    .timeSwitch {
      @include setFlexBetween;
      height: 30px;
      width: 95%;
      margin: 15px auto 0;

      .timePicker {
        width: 30%;
      }

      .interval {
        width: 20%;
        margin: 0 10px;
      }
    }

    .rankChartsBox {
      height: 484px;
      // height: calc(100% - 75px);
      padding: 20px;
    }
  }
}
</style>
